import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import Header from '../body_root/header.jsx';
import Footers from '../body_root/footer.jsx';
import Navbar from '../body_root/Navbar.jsx';
import './create_company.css';
import { Toast } from '../components_root/ToastContext.jsx';
import { MdLocationCity } from "react-icons/md";
import { Randomcode } from "../components_root/rendom_code.js";
import { Createcompany } from "./createcompany.js";
import { Verify_stafftype_account } from "../company_root/staff_account_root/verify_stafftype_account.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Create_company() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [agreed, setAgreed] = useState(false);
    const [authorized, setAuthorized] = useState(false);
    const [loading, setLoading] = useState(false);
    const [slug, setSlug] = useState("");
    const [company, setCompany] = useState("");
    const [brandname, setBrandname] = useState("");
    const [domain_registration, setDomain_registration] = useState("aooz.in");
    const [servicesdata, setServicesdata] = useState([]);
    const [serviceid, setServiceId] = useState("GZ3ueiAx1f2omr7YFrzL");
    const [servicetablename, setServicetablename] = useState("company");

    //staff account verify
    const [staffstatus, setStaffstatus] = useState(false);
    const [staffdata, setStaffdata] = useState([]);
    useEffect(() => {
        const verifyStaffAccount = async () => {
            const accountguid = Cookies.get("guid");
            const result = await Verify_stafftype_account(accountguid);
            if (result.success) {
                setStaffdata(result.data);
                setStaffstatus(true);
            }
        };
        verifyStaffAccount();
    }, []);

    

useEffect(() => {
    const fetch = async () => {
        const guid = Cookies.get("guid");

        const docRef = doc(db, "servicesdb", serviceid);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) return;

        const serviceId = docSnap.id;
        const serviceData = docSnap.data();

        let companyServices = [];

        if (guid) {
            const tablename = "companies";
            const q = query(
                collection(db, tablename),
                where("guid", "==", guid)
            );
            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                const companyUid = snapshot.docs[0].id;
                const serviceTable = serviceData.servicetablename;

                const serviceCollectionRef = collection(
                    db,
                    tablename,
                    companyUid,
                    serviceTable
                );

                const companySnap = await getDocs(serviceCollectionRef);
                companyServices = companySnap.docs.map(c => ({
                    id: c.id,
                    ...c.data()
                }));
            }
        }

        setServicesdata([
            {
                id: serviceId,
                ...serviceData,
                companyServices
            }
        ]);
    };

    fetch();
}, []);

    const post_Createcompany = async () => {
        const guid = Cookies.get("guid");
        if (!guid) return Toastshow("Please login first");
        if (!authorized) return Toastshow("Please authorized");
        if (!agreed) return Toastshow("Please agreed terms");
        if (!slug) return Toastshow("Please enter slug");
        if (!company) return Toastshow("Please enter company");
        if (!brandname) return Toastshow("Please enter brandname");
        const companyuid = Randomcode(26);
        try {
            setLoading(true);
            const result = await Createcompany({
                company,
                name: company,
                servicetablename,
                companyuid,
                ...servicesdata[0],
                domain_registration,
                serviceid,
                slug,
                brandname,
                logo_uid: "null",
                banner_uid: "null",
                banner_url: "https://firebasestorage.googleapis.com/v0/b/aoozpayment.firebasestorage.app/o/services_icon%2Fsite_design.jpg?alt=media&token=8df269d3-5a6e-4c66-972a-95a7746547d3",


            });

            if (result.success) {
                setLoading(false);
                Toastshow("Successfully!");
                 Cookies.set("select_company_uid", companyuid, { expires: 365, path: "/" });
                navigate('/company');

            } else {
                setLoading(false);
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            setLoading(false);
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };
    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const handleChange = (e) => {
        const raw = e.target.value.toLowerCase();
        const interim = raw.replace(/[^a-z0-9.-]/g, ""); // allow dots and hyphens while typing
        setDomain_registration(interim);
    };

    // Strict normalization: remove protocol, leading www., trailing path/slash,
    // collapse subdomains keeping last two labels (sld.tld).
    const normalizeDomain = (value) => {
        if (!value) return "";
        let v = value.toLowerCase().trim();

        // Remove protocol
        v = v.replace(/^https?:\/\//, "");

        // Remove everything after first slash (path, query, fragment)
        v = v.replace(/\/.*$/, "");

        // Remove leading "www."
        v = v.replace(/^www\./, "");

        // Remove any characters not allowed in domain labels (defensive)
        v = v.replace(/[^a-z0-9.-]/g, "");

        // Split labels and keep only last two parts (example.co.uk will become co.uk -> if you need support for multi-part TLDs, see note)
        const parts = v.split(".").filter(Boolean);
        if (parts.length === 0) return "";
        if (parts.length === 1) return parts[0]; // single label (e.g., "localhost" or incomplete)
        // If domain looks like ip address (numbers and dots), keep as-is
        const isIp = parts.every((p) => /^\d+$/.test(p));
        if (isIp) return parts.join(".");

        // Keep last two labels (sld.tld)
        v = parts.slice(-2).join(".");

        // Final defensive cleanup: only one dot between labels
        v = v.replace(/\.{2,}/g, ".");
        // Remove leading/trailing dots or hyphens
        v = v.replace(/^[.-]+|[.-]+$/g, "");

        return v;
    };

    // When user leaves the field, ensure final form like "aooz.in"
    const handleBlur = (e) => {
        setDomain_registration((current) => normalizeDomain(current));
    };

    // Clean pasted values immediately
    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = (e.clipboardData || window.clipboardData).getData("text");
        const cleaned = normalizeDomain(pasted);
        setDomain_registration(cleaned);
    };
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    <div className="company-body p-4">
                        <div className="text-hero-sub bold">Hello</div>
                        <div className="text-h1">Welcome back to aooz</div>
                        <div className="rounded p-2 ">
                            {/* Display services */}

                            {servicesdata.length > 0 && servicesdata.map((row) => (
                                <div key={row.id} className="ui-items items-back">
                                    <table >
                                        <tr><td width={30}> <img src={row.logo_url} className="service_photo rounded" /></td>
                                            <td>
                                                <table  >
                                                    <tr>
                                                        <td>
                                                            <div className="text-h1 bold text-pre">{row.name}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>

                                                        <td>
                                                            <div className="text-h3 text-pre text-off">{row.description}</div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>

                                    {/* <div className='service_price_body items-back b-dot-2 rounded p-11'>
                                        <table >
                                            <tr>
                                                <td width={60}>
                                                    <div className="text-h2 fcap text-off" >Price</div>
                                                </td>
                                                <td>
                                                    <div className="text-h2 bold fcap" >₹{row.price}/-</div>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={130}>
                                                    <div className="text-h2 fcap text-off" >Stories</div>
                                                </td>
                                                <td>
                                                    <div className="text-h2 fcap" >₹{row.stories_rant} MB</div>

                                                </td>
                                            </tr>

                                            <tr>
                                                <td width={130}>
                                                    <div className="text-h2 fcap text-off" >Stories </div>
                                                </td>
                                                <td>
                                                    <div className="text-h2 fcap" >₹{row.stories_mb} MB</div>

                                                </td>
                                            </tr>

                                            <tr>
                                                <td width={130}>
                                                    <div className="text-h2 fcap text-off" >Stories Topup</div>
                                                </td>
                                                <td>
                                                    <div className="text-h2 bold fcap" >₹{row.stories_rate}/-</div>

                                                </td>
                                            </tr>

                                            <tr>
                                                <td width={130}>
                                                    <div className="text-h2 fcap text-off" >Validity day</div>
                                                </td>
                                                <td>
                                                    <div className="text-h2 bold fcap" >₹{row.validity_day}/-</div>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td width={130}>
                                                    <div className="text-h2 fcap text-off" >Tax (GST)</div>
                                                </td>
                                                <td>
                                                    <div className="text-h2 bold fcap" >₹{row.tax_rate}%</div>

                                                </td>
                                            </tr>
                                        </table>
                                    </div> */}
                                    <br />

                                    {row.companyServices.length > 0 ? (
                                        row.companyServices.map((compService) => (
                                            <div key={compService.id} className='button-ui text-h2 bold fcap p-22 cursor' onClick={() => navigate(`/${row.slug}`)}>Open {row.name} </div>
                                        ))
                                    ) : (
                                        <div>
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div className="border rounded  hover">
                                                            <input
                                                                className="fcap border-none p-1 text-h1 bold"
                                                                placeholder="Enter Comapny name "
                                                                value={company}
                                                                maxLength={50}
                                                                onChange={(e) => {
                                                                    setCompany(e.target.value);
                                                                    setSlug(normalize(normalize(e.target.value)));
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h3 text-off">Brand name</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="border rounded  hover">
                                                            <input
                                                                maxLength={30}
                                                                value={brandname}
                                                                onChange={(e) => setBrandname(e.target.value)

                                                                }
                                                                className="border-none p-1 text-h1"
                                                                placeholder="Enter Brand name"
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h3 text-off">User name</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="border rounded  hover">
                                                            <input
                                                                value={slug}
                                                                maxLength={60}
                                                                onChange={(e) => {
                                                                    setSlug(normalize(normalize(e.target.value)));
                                                                }}
                                                                className="border-none p-2 text-h2"
                                                                placeholder="Enter user name"
                                                            />

                                                        </div>
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <td>
                                                        <div className="text-h3 bold p-1">Domain name your company: </div>
                                                        <div className="border rounded  hover">
                                                            {domain_registration}
                                                             <input
                                                                value={domain_registration}
                                                                maxLength={60}
                                                                onChange={(e) => {
                                                                    let v = e.target.value.toLowerCase().trim();

                                                                    // Remove protocol
                                                                    v = v.replace(/^https?:\/\//, "");

                                                                    // Remove everything after first slash
                                                                    v = v.replace(/\/.*$/, "");

                                                                    // Remove leading "www."
                                                                    v = v.replace(/^www\./, "");

                                                                    // Remove unwanted characters
                                                                    v = v.replace(/[^a-z0-9.-]/g, "");

                                                                    // Split parts
                                                                    const parts = v.split(".").filter(Boolean);

                                                                    if (parts.length > 2) {
                                                                        // Keep only last two parts: domain + tld
                                                                        v = parts.slice(-2).join(".");
                                                                    }

                                                                    // Cleanup
                                                                    v = v.replace(/\.{2,}/g, ".");
                                                                    v = v.replace(/^[.-]+|[.-]+$/g, "");

                                                                    setDomain_registration(v);
                                                                }}
                                                                className="border-none p-2 text-h2"
                                                                placeholder="Enter domain name optional"
                                                            />  
                                                        </div>
                                                        <div className="text-h2 green m-1 ">DNS: Configure a CNAME record and point it to the domain aooz.in.</div>
                                                    </td>
                                                </tr> */}
                                                <tr>
                                                    <td>
                                                        <table>
                                                            <tr>
                                                                <td width={30}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={authorized}
                                                                        onChange={() => setAuthorized(!authorized)}
                                                                    />
                                                                </td>
                                                                <td>

                                                                    <label>
                                                                        {" "}
                                                                        I authorized for company person <a className='blue' href="/terms-authorized">Terms</a>
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <table>
                                                            <tr>
                                                                <td width={30}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={agreed}
                                                                        onChange={() => setAgreed(!agreed)}
                                                                    />
                                                                </td>
                                                                <td>

                                                                    <label>
                                                                        {" "}
                                                                        I agree to the <a className='blue' href="/terms">Terms and Conditions</a>
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>

                                                <br />
                                                <tr>
                                                    <td>
                                                        <div
                                                            onClick={() => post_Createcompany()}
                                                            className="button-ui fill p-33 text-h2 cursor"
                                                        >
                                                            {loading ? "Loading..." : "Continue"}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    )}
                                    <br />
                                    <div className="text-h3 text-pre test-off" >{row.about}</div>
                                </div>
                            ))}

                        </div>

                    </div>

                </div>

            </div>



        </div>
    );
}
